import { useEffect } from 'react';

import styles from './Alert.module.scss';

/**
 * Alert 컴포넌트
 * - 공용 알림창 컴포넌트
 * - 화면 정중앙에 표시
 * - mode: 'alert' | 'confirm'
 * - alert → 확인 버튼 1개
 * - confirm → 예 / 아니요 버튼
 * - 피그마 디자인 기반: node-id=988-6828
 *
 * @param {boolean} isOpen - 알림창 표시 여부
 * @param {string} message - 알림 메시지
 * @param {Function} onClose - 닫기 핸들러
 * @param {boolean} disableOverlayClick - 오버레이 클릭으로 닫기 방지 (인증 관련 Alert 등)
 * @param {string} className - 추가 CSS 클래스
 */
function Alert({
  isOpen,
  message,
  onClose,
  onConfirm,
  disableOverlayClick = false,
  className = '',
  mode = 'alert',
  confirmText = mode === 'alert' ? '확인' : '예',
  cancelText = '아니요',
}) {
  // 엔터키로 확인 버튼 누르기
  useEffect(
    function () {
      if (!isOpen) return;

      function handleKeyDown(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          // 확인 버튼 클릭과 동일한 동작
          if (onConfirm) onConfirm();
          onClose();
        }
      }

      window.addEventListener('keydown', handleKeyDown);
      return function () {
        window.removeEventListener('keydown', handleKeyDown);
      };
    },
    [isOpen, onClose, onConfirm],
  );

  if (!isOpen) {
    return null;
  }

  function handleOverlayClick(e) {
    // disableOverlayClick이 true이면 오버레이 클릭으로 닫기 방지
    if (disableOverlayClick) {
      return;
    }
    if (e.target === e.currentTarget) {
      onClose();
    }
  }

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={`${styles.alertContainer} ${className}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.titleContainer}>
          <p className={styles.title}>{message}</p>
        </div>
        <div className={styles.buttonContainer}>
          {mode === 'alert' ? (
            /** ALERT MODE: 확인 버튼 한 개 */
            <button
              type="button"
              className={styles.confirmButton}
              onClick={() => {
                if (onConfirm) onConfirm();
                onClose();
              }}
            >
              {confirmText}
            </button>
          ) : (
            /** CONFIRM MODE: 예 / 아니요 버튼 */
            <>
              <button type="button" className={styles.cancelButton} onClick={onClose}>
                {cancelText}
              </button>
              <button
                type="button"
                className={styles.confirmButton}
                onClick={() => {
                  if (onConfirm) onConfirm();
                  onClose();
                }}
              >
                {confirmText}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Alert;
